import isEmpty from "lodash-es/isEmpty";
import { useCurrentUser } from "./useCurrentUser";

export const useIsSubUser = () => {
  const currentUser = useCurrentUser();

  return !isEmpty(currentUser?.parentUserId);
};
